import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class MapService {
    private readonly getAllInMapURL = `/customer-map/all`;
    private readonly importCustomersMapURL = `/customer-map/import`;
    private readonly addDescriptionMapURL = `/customer-map`;
    // ---------------------------------------------------------------

    getMap() {
        return fetchWithRetry(API.get(this.getAllInMapURL));
    }

    importCustomersMap(body: FormData) {
        return fetchWithRetry(
            API.post(this.importCustomersMapURL, body, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    addDescriptionMap(id: number, body: { description: string }) {
        return fetchWithRetry(API.patch(`${this.addDescriptionMapURL}/${id}/description`, body));
    }
}

export default new MapService();
